/**
 * Saga helpers for tvchartData overlay markers (media / OPS-OPD / insider).
 * Kept free of generator effects so unit tests can cover stock-switch races.
 */
import isActiveChartMarkerStock from "./isActiveChartMarkerStock";

export function shouldApplyFetchedChartMarkerData(activeStockId, stockId) {
  return isActiveChartMarkerStock(activeStockId, stockId);
}
